import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)


const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../pages/Index.vue'),
    redirect: '/main',
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('../pages/Login.vue')
      },
      {
        path: '/myhome',
        name: 'myhome',
        component: () => import('../pages/home/MyHome.vue')
      },
      {
        path: '/main',
        name: 'main',
        component: () => import('../components/Main.vue'),
        meta:{
          title:"主页"
        }
      },
      {
        path: '/question/insert',
        name: 'questionInsert',
        component: () => import('../pages/question_manage/InsertQuestion.vue')
      },
      {
        path: '/question/edit',
        name: 'questionEdit',
        component: () => import('../pages/question_manage/EditQuestion.vue')
      },
      {
        path: '/question/edit/detail',
        name: 'EditQuestionDetail',
        component: () => import('../pages/question_manage/EditQuestionDetail.vue')
      },
      {
        path: '/question/verify',
        name: 'questionVerify',
        component: () => import('../pages/question_manage/VerifyQuestion.vue')
      },
      {
        path: '/exam/online',
        name: 'ExamOnline',
        component: () => import('../pages/exam/ExamOnline.vue')
      },
      {
        path: '/exam/list',
        name: 'ExamList',
        component: () => import('../pages/exam/ExamList.vue')
      },
      {
        path: '/exercise/sequential',
        name: 'SequentialExercise',
        component: () => import('../pages/exercise/SequentialExercise.vue')
      },
      {
        path: '/exercise/favourite',
        name: 'FavouriteExercise',
        component: () => import('../pages/exercise/FavouriteExercise.vue')
      },
      {
        path: '/favourite/exercise/view',
        name: 'FavouriteExerciseView',
        component: () => import('../pages/exercise/FavouriteExerciseView.vue')
      },
      {
        path: '/exercise/wrong',
        name: 'WrongExercise',
        component: () => import('../pages/exercise/WrongExercise.vue')
      },
      {
        path: '/student/manage',
        name: 'StudentManage',
        component: () => import('../pages/student_manage/StudentManage.vue')
      },
      {
        path: '/student/export',
        name: 'ExportScore',
        component: () => import('../pages/student_manage/ExportScore.vue')
      },
      {
        path: '/sequential/exercise/view',
        name: 'SequentialExerciseView',
        component: () => import('../pages/exercise/SequentialExerciseView.vue')
      },
      {
        path: '/wrong/exercise/view',
        name: 'WrongExerciseView',
        component: () => import('../pages/exercise/WrongExerciseView.vue')
      },
      {
        path: '/question/verify/detail',
        name: 'VerifyQuestionDetail',
        component: () => import('../pages/question_manage/VerifyQuestionDetail.vue')
      },
      {
        path: '/exam/list/detail',
        name: 'ExamHistoryDetail',
        component: () => import('../pages/exam/ExamHistoryDetail.vue')
      },
      {
        path: '/exam/export',
        name: 'ExamExportWord',
        component: () => import('../pages/exam/ExamExportWord.vue')
      },
      {
        path: '/ai/exercise',
        name: 'AIExercise',
        component: () => import('../pages/exercise/AIExercise.vue')
      },
      {
        path: '/ai/exercise/view',
        name: 'AIExerciseView',
        component: () => import('../pages/exercise/AIExerciseView.vue')
      },
    ]

  },
  {
    path: '/password/change',
    name: 'ChangePassword',
    component: () => import('../pages/ChangePassword.vue')
  },
  
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// router.onError((error) => {
//   let pattern = /Loading chunk (.*) failed\./;
//   if (pattern.test(error.message)) {
//       location.reload(true);
//   }
// })


export default router
